export default __webpack_public_path__ + "static/sashFlat1ColorDphBluePms281-2d7a743a45411bc5ae2caa9d30463b59.png";